import React from "react";
import Cropper from "react-easy-crop";
import { Point, Area } from "react-easy-crop/types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";
import { ImageListType } from "react-images-uploading";

interface imageCropProps {
  open: boolean;
  handleClose: () => void;
  imageList: ImageListType;
  crop: Point;
  zoom: number;
  setCrop: React.Dispatch<React.SetStateAction<Point>>;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  onImageUpdate: (index: number) => void;
  cropWidth: number;
  cropHeight: number;
}

const ImageCropPopUp: React.FC<imageCropProps> = ({
  open,
  handleClose,
  imageList,
  crop,
  zoom,
  setCrop,
  onCropComplete,
  setZoom,
  onImageUpdate,
  cropWidth,
  cropHeight,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            letterSpacing: "0.36px",
            color: "#333333",
            opacity: 1,
            fontFamily: "Avenir",
            fontSize: {
              xs: "15px",
              sm: "17px",
              md: "19px",
            },
            lineHeight: {
              xs: "20px",
              sm: "23px",
              md: "25px",
            },
          }}
        >
          {"Edit Photo"}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: { xs: "250px", sm: "274px", md: "467px", xl: "558px" },
              height: { xs: "150px", sm: "150px", md: "246px", xl: "346px" },
              backgroundColor: "#DEEDFE",
              boxShadow: "0px 0px 6px #00000029",
              border: "1px solid #2685F899",
              borderRadius: "4px",
              opacity: 1,
            }}
          >
            <Cropper
              image={imageList[0].dataURL}
              crop={crop}
              zoom={zoom}
              aspect={cropWidth / cropHeight}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              style={{
                containerStyle: {
                  position: "relative",
                  width: "100%",
                  height: "100%",
                },
                mediaStyle: {
                  // width: "100%",
                  // height: "100%",
                },
                cropAreaStyle: {
                  // width: "100px",
                  // height: "50px",
                },
              }}
              disableAutomaticStylesInjection={false}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onImageUpdate(0)}
            sx={{
              letterSpacing: "0.36px",
              color: "#2685f8",
              opacity: 1,
              fontFamily: "Avenir",
              fontSize: {
                xs: "10px",
                sm: "12px",
                md: "14px",
              },
              lineHeight: {
                xs: "16px",
                sm: "18px",
                md: "20px",
              },
              fontWeight: "400",
            }}
          >
            Change Image
          </Button>
          <Button
            onClick={handleClose}
            autoFocus
            sx={{
              letterSpacing: "0.36px",
              color: "#2685f8",
              opacity: 1,
              fontFamily: "Avenir",
              fontSize: {
                xs: "10px",
                sm: "12px",
                md: "14px",
              },
              lineHeight: {
                xs: "16px",
                sm: "18px",
                md: "20px",
              },
            }}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ImageCropPopUp;
